import { useMemo } from 'react'
import { useActiveSubscriptions } from '@src/hooks/useActiveSubscriptions.ts'

export const useActiveVideoSubscription = () => {
  const subscriptions = useActiveSubscriptions()
  const videoCallSubscriptions = subscriptions
    .filter((s) => s.primaryProduct.bundledPaidCalls)
    .sort((s1, s2) => s1.startAt - s2.startAt)

  const videoCallSubscription =
    videoCallSubscriptions.find((s) => s.primaryProduct.recurring) ||
    (videoCallSubscriptions[videoCallSubscriptions.length - 1] as
      | typeof videoCallSubscriptions[0]
      | undefined)

  const videoCallSubscriptionProduct = useMemo(() => {
    if (!videoCallSubscription) {
      return null
    }
    const product = videoCallSubscription.primaryProduct

    if (product.ehrSchedulingRule.count) {
      return product
    }

    return product.includedGoods.find((good) => good.ehrSchedulingRule.count)
  }, [videoCallSubscription])

  return { videoCallSubscription, videoCallSubscriptionProduct }
}
